import { render } from "./VideoCover.vue?vue&type=template&id=f016c9e4"
import script from "./VideoCover.vue?vue&type=script&lang=js"
export * from "./VideoCover.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__